module.exports = __webpack_public_path__ + "static/media/horizontal-align-center.17bec903.svg";